const faDiamondHalfStroke = {
  prefix: 'fal',
  iconName: 'diamond-half-stroke',
  icon: [
    512,
    512,
    [],
    'e5b8',
    'M499.1 224.6L287.6 13.1c-17.4-17.3-45.7-17.3-63 0L13.1 224.6c-17.3 17.4-17.3 45.7 0 63l211.5 211.5c8.7 8.7 20.1 13 31.6 13s22.8-4.3 31.5-13l211.5-211.5c17.3-17.4 17.3-45.7 0-63zm-29.7 33.2L261.5 450.6V61.6l207.9 192.9c.9 .9 .9 2.4 0 3.3z',
  ],
};
export default faDiamondHalfStroke;
